import React, { useEffect, useState } from 'react';
import InputField from '../../components/UI/Forms/InputField';
import { FieldValues, useForm } from 'react-hook-form';
import ErrorMessage from '../../components/UI/Notifications/ErrorMessage';
import Button from '../../components/UI/Buttons/Button';
import { Link, useNavigate } from 'react-router-dom';
import { validationSchema } from '../../utility/validation';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL } from '../../api/constant';
import { getDeviceId, setCookies, showToastNotification } from '../../utility/helper';
import { IRole, IUser } from '../../interfaces/user';
import { useDispatch, useSelector } from 'react-redux';
import { requestForToken } from '../../firebase-messaging';
import { AppDispatch } from '../../store';
import { setUserDetails } from '../../store/actions/actions';

const Login: React.FC = () => {

    const roles: IRole[] = useSelector((state: any) => state.root.roles)
    const { register, handleSubmit, formState: { errors } } = useForm({ mode: 'onBlur' });
    const navigate = useNavigate();
    const [role, setRole] = useState<'admin' | 'ordermoniter'>('admin');
    const dispatch = useDispatch<AppDispatch>()
    const [loading, setLoading] = useState<boolean>(false)
    const searchRole = role === 'admin' ? 'admin' : 'ordermoniter';
    const roleId = roles.find((r: IRole) => r.name.toLowerCase().includes(searchRole))?.id;
    const [fcmToken, setFCMToken] = useState<string | null>(null);

    useEffect(() => {
        getFirebaseData();
    }, [])

    const getFirebaseData = async () => {
        const token = await requestForToken();
        console.log("FCM Token: ", token);
        setFCMToken(token)
    }

    const onSubmit = async (data: FieldValues) => {
        console.log("Form Data: ", roleId);
        setLoading(true)
        let postData = {
            "identifier": data.email,
            "password": data.password,
            "deviceId": getDeviceId(),
            deviceToken: fcmToken,
            "roleId": roleId
        }
        try {
            const response: { accessToken: string, refreshToken: string } = await callApi(API_URL + API_ENDPOINT.auth + 'user/login', { data: postData, method: 'POST' });
            setCookies(import.meta.env.VITE_BUSINESS + 'token', response.accessToken)
            setCookies(import.meta.env.VITE_BUSINESS + 'refreshToken', response.refreshToken);
            setCookies(import.meta.env.VITE_BUSINESS + "deviceToken", fcmToken);
            getUserDetails();
            setLoading(false)
            if (role === 'admin') {
                navigate('/dashboard')
            } else {
                navigate('/order-monitor')
            }
        } catch (error: any) {
            setLoading(false)
            showToastNotification('danger', error.message)
        }
    }

    const getUserDetails = async () => {
        try {
            const response: IUser = await callApi(API_URL + API_ENDPOINT.auth + 'user/detail', { method: 'GET' });
            dispatch(setUserDetails(response))
            console.log(response)
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <div className='app-login app-login p-0 position-relative'>
            <div className="app-auth-body mx-auto position-relative z-1">
                <div className="app-auth-branding mb-4"><a className="app-logo" href="javascript:void(0)"><img className="logo-icon" src="/assets/images/app-logo.svg" alt="logo" /></a></div>
                <h2 className="auth-heading text-center mb-5 text-white">Log in</h2>
                <div className="auth-form-container text-start">
                    <form className="auth-form login-form" onSubmit={handleSubmit(onSubmit)} >
                        <div className="email mb-3">
                            <label className="sr-only text-white mb-1" htmlFor="signin-email">Email</label>
                            <InputField register={register('email', {
                                required: validationSchema.email.required,
                                pattern: {
                                    value: validationSchema.email.pattern.regex,
                                    message: validationSchema.email.pattern.message
                                }
                            })} name="email" type="email" className="signin-email" placeholder="Email address" />
                            <ErrorMessage message={errors.email?.message?.toString()} className='text-danger' />
                        </div>
                        <div className="password mb-3">
                            <label className="sr-only text-white mb-1" htmlFor="signin-password">Password</label>
                            <InputField register={register('password', {
                                required: validationSchema.password.required,
                            })} name="password" type="password" className="signin-password" placeholder="Password" />
                            <ErrorMessage message={errors.password?.message?.toString()} className='text-danger' />
                            <div className="extra mt-3 row justify-content-between">
                                <div className="col-6">
                                </div>
                                <div className="col-6">
                                    <div className="forgot-password text-end">
                                        <Link className='fw-semibold' to={"/forgot-password"} >Forgot password?</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="role-selection mb-3">
                            <label className="text-white mb-1">Select Role:</label>
                            <div className="d-flex gap-3">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="role"
                                        id="roleAdmin"
                                        value="admin"
                                        checked={role === 'admin'}
                                        onChange={() => setRole('admin')}
                                    />
                                    <label className="form-check-label text-white" htmlFor="roleAdmin">
                                        Admin
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="role"
                                        id="roleOrderMonitor"
                                        value="orderMonitor"
                                        checked={role === 'ordermoniter'}
                                        onChange={() => setRole('ordermoniter')}
                                    />
                                    <label className="form-check-label text-white" htmlFor="roleOrderMonitor">
                                        Order Monitor
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <Button type="submit" loading={loading} className="app-btn-primary w-100 theme-btn mx-auto" text='Log In' />
                        </div>
                    </form>

                </div>
            </div>

            <div className="auth-background-holder">
            </div>
        </div>
    )
}

export default Login